import type { Window } from '../api/queries';

const HOUR_MS = 3_600_000;

export const WINDOW_HOURS = { '6h': 6, '1d': 24, '3d': 72, '7d': 168 } as const;

export type WindowKey = keyof typeof WINDOW_HOURS;

export const WINDOW_KEYS = Object.keys(WINDOW_HOURS) as WindowKey[];

/** The `[from, to]` range a window key names, ending at `now`. */
export function windowFor(key: WindowKey, now: Date): Window {
  return {
    from: new Date(now.getTime() - WINDOW_HOURS[key] * HOUR_MS).toISOString(),
    to: now.toISOString(),
  };
}
